module.exports = __webpack_public_path__ + "static/img/icon_fenzr.4ccb3ebc.svg";